/** Skeleton screens em vez de spinner bloqueante (RF-UX-076). */

export function ConversationListSkeleton({ rows = 8 }: { rows?: number }) {
  return (
    <div className="list" role="list" aria-busy="true" aria-label="Carregando conversas">
      {Array.from({ length: rows }).map((_, index) => (
        <div className="row" role="listitem" key={index}>
          <span className="row-avatar" style={{ width: 54, height: 54, flex: "0 0 54px" }} />
          <div className="row-body">
            <div className="row-top">
              <div className="skeleton w-[42%]" />
              <div className="skeleton h-3 w-[36px]" />
            </div>
            <div className="row-bottom">
              <div className="skeleton w-[82%]" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export function ChatSkeleton() {
  return (
    <div className="chat-scroll" role="status" aria-busy="true" aria-label="Carregando mensagens">
      <div className="skeleton h-4 w-24 self-center" />
      <div className="skeleton h-12 w-[70%] self-start rounded-lg" />
      <div className="skeleton h-12 w-[60%] self-end rounded-lg" />
      <div className="skeleton h-12 w-[75%] self-start rounded-lg" />
      <div className="skeleton h-12 w-[50%] self-end rounded-lg" />
    </div>
  );
}

export function CardSkeleton() {
  return (
    <div className="card" aria-busy="true">
      <div className="mb-3 flex items-center gap-3">
        <div className="skeleton h-11 w-11 rounded-full" />
        <div className="flex-1">
          <div className="skeleton mb-2 w-2/5" />
          <div className="skeleton w-3/5" />
        </div>
      </div>
      <div className="skeleton mb-2 w-full" />
      <div className="skeleton w-4/5" />
    </div>
  );
}
